var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { attrs: { id: "topBanner" } }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "alignBox" }, [
          _c("img", {
            staticClass: "banCateg",
            class: { "initial-filter": _vm.shop.info.hideDegradeCategory },
            attrs: {
              src: _vm.UrlService.imagePath(
                _vm.product.ShopId,
                _vm.product.ims
              ),
              alt: _vm.product.dn,
            },
            on: {
              error: function ($event) {
                $event.target.src = "dist/assets/no-img.png"
              },
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "blocImg d-flex justify-content-center align-items-center flex-column",
            },
            [
              _vm.shop.closed &&
              _vm.product.ty == _vm.PRODUCT_TYPES.RootCategory
                ? _c("h1", { staticClass: "blocTitle" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.shop.info.closedDescription) +
                        "\n\t\t\t\t\t"
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.product.ty !== _vm.PRODUCT_TYPES.Menu
                ? _c(
                    "div",
                    { staticClass: "blocTitle", attrs: { id: "titlePage" } },
                    [
                      _c("h1", { staticClass: "sidebar-brand" }, [
                        _c("span", { attrs: { "xone-line": "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.truncate(
                                _vm.product.dn,
                                _vm.DISPLAY_LENGTH.global.product.title
                              )
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      !_vm.product.dd ? _c("p", [_vm._v(" ")]) : _vm._e(),
                      _vm._v(" "),
                      _vm.product.dd
                        ? _c("p", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.truncate(
                                  _vm.product.dd,
                                  _vm.DISPLAY_LENGTH.global.product.desc
                                )
                              ),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.product.Promo
                        ? _c("promo-grid-view", { attrs: { chevrons: true } })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.product.ty == _vm.PRODUCT_TYPES.Category
                        ? _c("span", { staticClass: "priceTitle" }, [
                            _vm._v(
                              _vm._s(_vm.ShopService.prix(_vm.product.dp, ""))
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.product.allergens || _vm.product.consumables
                ? _c(
                    "div",
                    { staticClass: "pos-absolute bottom-0 mb-30" },
                    [_c("product-tags", { attrs: { product: _vm.product } })],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "main" }, [
      _c("div", { staticClass: "container-fluid" }, [
        [_vm.PRODUCT_TYPES.Category, _vm.PRODUCT_TYPES.RootCategory].includes(
          _vm.product.ty
        )
          ? _c(
              "div",
              {
                class: {
                  categoryBloc: !_vm.shop.info.display.itemChildList,
                  "categoryBlocList bg-grey3":
                    _vm.shop.info.display.itemChildList,
                },
              },
              [
                _c("div", { staticClass: "container" }, [
                  _c("div", [
                    _c("div", { staticClass: "productBloc" }, [
                      _c(
                        "ul",
                        { staticClass: "row" },
                        _vm._l(_vm.availableChilds, function (child, i) {
                          return _c("item-child-grid", {
                            key: i,
                            attrs: {
                              item: child,
                              cart: _vm.cart,
                              shop: _vm.shop,
                            },
                          })
                        }),
                        1
                      ),
                    ]),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.product.ty == _vm.PRODUCT_TYPES.Product &&
        _vm.product.options.length
          ? _c(
              "div",
              { staticStyle: { "margin-top": "30px" } },
              [_c("product-options", { attrs: { "cart-item": _vm.cartItem } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.product.ty == _vm.PRODUCT_TYPES.Menu
          ? _c(
              "div",
              { staticClass: "menuCateg bg-grey3" },
              [
                _c("menu-categories", {
                  attrs: { "cart-item": _vm.cartItem },
                  on: { "add-to-cart": _vm.addToCart },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }